import { useInputFields } from "../../lib/hooksLib";
import { FormInput,CardContainer } from "../../components";
import { ReactComponent as Off } from "../../assets/icons/checker-off.svg";
import { ReactComponent as On } from "../../assets/icons/checker-on.svg";
import {
  createFields, validateInputValue
} from "../../components/PostFormSection";


const inputFields = [
  {
    name: "userID",
    displayName: "사용자 아이디",
  },
  {
    name: "password",
    displayName: "비밀번호",
    inputType: "password"
  },
  {
    name: "isSoldout",
    displayName: "Checkbox",
    inputType: "checkbox",
    comment: "간단한 상품정보 설명...",
  },
  {
    name: "description",
    displayName: "Text Input",
    inputType: "textarea",
  },
  {
    name: "image",
    displayName: "Image File",
    inputType: "file",
    required: false,
  },
]

export default function FormExamples() {
  // const inputFields = db.shopItemUpdate.inputFields;
  const [fields, setFields] = useInputFields(
    createFields({ inputFields, editItems: null })
  );
  return (
    <CardContainer>
      {
        inputFields.map((item, index) => {

          const myProps = {
            key: index,
            name: item.name,
            label: item.displayName,
            type: item.type || "text",
            value: fields[item.name],
            onChange: setFields,
            placeholder: item.placeholder || item.name,
            validated: validateInputValue(item, fields[item.name]),
            readOnly: item.readOnly || false,
            comment: item.comment,
            inputType: item.inputType || "text",
            selectList: item.selectList || [],
            checked: item.inputType === "checkbox" && fields[item.name],
          };

          return <FormInput {...myProps} />;
        })
      }

      {/* <On width={20}/>
      <Off width={20} /> */}

    </CardContainer>
  )
}